<template>
	<el-container>
		<Menu :activeIndex='activeIndex'></Menu>
		<el-container>
			<el-header>
				<h2>优惠券</h2>
			</el-header>
			<el-main>
				<div class='editConpon clearfix'>
					<!--<div class='box_item'>
						优惠券金额：
						<el-input style="width:300px" placeholder="金额" type="number" v-model="conponMon"></el-input> 元
					</div>-->
					<div class="box_item ">
						开始时间：
						<el-date-picker v-model="rangeDate" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
						</el-date-picker>
					</div>
					<div class="box_item">
						优惠券类别：
						<el-select v-model="typeId" placeholder="请选择">
						    <el-option
						      v-for="item in conponTypeData"
						      :key="item.id"
						      :label="item.amount+'元 — '+item.instructions"
						      :value="item.id">
						    </el-option>
						  </el-select>
					</div>
					<div class="box_item">
						<el-input placeholder="请输入学员ID查找" v-model="searchname" class="input-with-select">
    						<el-button slot="append" icon="el-icon-search" v-on:click="seachstudent"></el-button>
  						</el-input>
					</div>

					<!--<div class="box_item">
						<el-button type="success" style="margin-bottom:20px;" v-on:click='sendConpon' :disabled='sendState'>赠送优惠券</el-button>
					</div>-->
				</div>

				<el-table ref="multipleTable" :data="tableData" :stripe="true" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
					<!--<el-table-column type="selection" width="55">
					</el-table-column>-->
					<el-table-column label="头像" width="200">
						<div slot-scope="scope">
							<img :src="scope.row.headimgurl" alt="" style="width: 100px;margin-top:5px;">
						</div>
					</el-table-column>
					<el-table-column prop="nickname" label="昵称" width="120" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="city" label="城市" show-overflow-tooltip>
					</el-table-column>
					<el-table-column label="查看">
						<template slot-scope="scope">
							<el-button type="primary" size="mini" plain @click="getData(scope.row.openid),dialogTableVisible = true">查看优惠券</el-button>
						</template>
					</el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button type="success" size="mini" plain v-on:click="sendOneConpon(scope.row.openid)">赠送优惠券</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination style="background:#fff;" :page-size="pagecount" @current-change="handleCurrentChange" :current-page.sync="currentPage1" layout="prev, pager, next" :total="dataTotal"></el-pagination>
				<!--查看优惠券-->
				<el-dialog title="优惠券详情" class='myCoupon' :visible.sync="dialogTableVisible">
				  	<div class="coupon_card">
					    <div v-for="(item,index) in pointData" :key="index">
						    <div class="item" v-if="item.use_state == 1"><!--可用-->
						      	<div class="_detail">
						        	<span class="_big" v-text="item.amount"></span>元
						        	<p class="item_points">有效期至
						        		<span v-text="item.end_time"></span>
						        	</p>
						      	</div>
							    <div class="_time" v-text="item.instructions"></div>
							    <i class="delconpon el-icon-delete" v-on:click="delconpon(item.id)"></i>
							</div>
							<div class="item" v-if="item.use_state == 0"><!--已使用-->
						      	<div class="_detail">
						        	<span class="_big" v-text="item.amount"></span>元
						        	<p class="item_points">有效期至 <span v-text="item.end_time"></span></p>
						      	</div>
						      	<div class="_time" v-text="item.instructions"></div>
						      	<div class="_used">
						        	<img src="../../static/img/used.png" />
						      	</div>
						    </div>
						    <div class="item" v-if="item.use_state == 2"><!--已过期-->
						      	<div class="_detail">
						        	<span class="_big" v-text="item.amount"></span>元
						        	<p class="item_points">有效期至 <span v-text="item.end_time"></span></p>
						      	</div>
						      	<div class="_time" v-text="item.instructions"></div>
						      	<div class="_used">
						        	<img src="../../static/img/overTime.png" />
						      	</div>
						    </div>
						</div>
						<div class="no_class" v-if="pointData.length == 0">
							<i class="iconfont icon-baoqian"></i>
							暂无优惠券
						</div>
					</div>
				</el-dialog>

				<!--查看优惠券-->
			</el-main>
			<el-footer>Copyright &copy; Soren外刊精读 技术支持 ：
				<a href="#">苏州西西弗斯商务信息咨询有限公司</a>
			</el-footer>
		</el-container>

	</el-container>

</template>

<script>
	export default {
		data() {
			return {
				activeIndex: "4",
				tableData: [],
				multipleSelection: [],
				conponMon: 0,
				sendState: true,
				dialogTableVisible:false,
				rangeDate:null, //优惠券起止时间
				pointData: [],
				currentPage1:1,
				pagecount:20,
				dataTotal:0,
				searchname:'',
				conponTypeData:[],
				typeId:"",
				curentOid:""
			};
		},
		created() {

		},
		updated: function() {

		},
		mounted(){
			this.getVipPerSons(1,this.searchname);
			this.getConponType();
		},
		methods: {
			delconpon:function(id){
				var that = this;
				this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          			confirmButtonText: '确定',
          			cancelButtonText: '取消',
          			type: 'warning'
        		}).then(() => {
        			that.axios.post("/myCoupon/delete", {
						mark: localStorage.getItem("mark"),
						id:id
					})
					.then(function(response) {
						if(response.data.code == "600") {
							that.$message({
		            			type: 'success',
		            			message: '删除成功!'
		          			});
							that.axios.post('coupon/queryMyCoupon', {
								openid:that.curentOid
							})
							.then((res) => {
								if(res.data.code == 600){
									that.pointData = res.data.data;
									console.log(that.pointData)
								}

							})
						} else if(response.data.code == "400") {
							that.$message({
								type: "error",
								message: "操作失败"
							});
						}
					})
					.catch(function(error) {
						console.log(error);
					});

        		}).catch(() => {
	          		that.$message({
	            		type: 'info',
	            		message: '已取消删除'
	          		});
        		});
			},
			getConponType:function(){
				var that = this;
				that.axios.post("/coupon/list", {
					mark: localStorage.getItem("mark")
				})
				.then(function(response) {
					if(response.data.code == "600") {
						that.conponTypeData = response.data.data;
						console.log(that.conponTypeData);
					} else if(response.data.code == "400") {
						that.$message({
							type: "error",
							message: "操作失败"
						});
					}
				})
				.catch(function(error) {
					console.log(error);
				});
			},
			seachstudent:function(){
				var that = this;
				this.getVipPerSons(1,this.searchname);
			},
			handleCurrentChange:function(page){
				this.getVipPerSons(page,this.searchname);
			},
			getData:function(openid){
				var that = this;
				//console.log("111111111111");
				that.curentOid = openid;
				that.axios.post('https://soren.guanqimiao.cn/Coupon/queryUserCoupon', {
					openid:openid
				})
				.then((res) => {
					if(res.data){
						that.pointData = res.data;
						console.log(that.pointData)
					}

				})
			},
			sendOneConpon:function(openid){
				var that = this;
				if(that.rangeDate == null || that.rangeDate == undefined) {
					that.$message({
						type: "error",
						message: "未设置起止时间"
					});
				}else if(that.typeId == ""){
					that.$message({
						type: "error",
						message: "未选择优惠券种类"
					});
				}else{
					that.axios.post("https://soren.guanqimiao.cn/MyCoupon/addCouponOne", {
						mark:'xueqiu',
						coupon_id:that.typeId,
						use_state:1,
						openid:openid,
						start_time:that.rangeDate[0],
						end_time:that.rangeDate[1]
					})
					.then(function(response) {
						if(response.data.code == "600") {
							//that.typeId = "";
							that.$message({
					          	message: '添加成功',
					          	type: 'success'
					        });
						} else if(response.data.code == "400") {
							console.log(response);
							that.$message({
								type: "error",
								message: "操作失败"
							});
						} else {
							that.ifLogin();
						}

					})
					.catch(function(error) {
						console.log(error);
					});
				}

			},
			sendConpon: function() {
				var that = this;
				console.log(that.rangeDate);
				if(that.multipleSelection.length == 0) {
					that.$message({
						type: "error",
						message: "还没有选择要赠送的对象"
					});
				}else{
					that.axios.post("/myCoupon/add", {
						mark: localStorage.getItem("mark"),
						coupon_id:1,
						openid:that.multipleSelection,
						start_time:that.rangeDate[0],
						end_time:that.rangeDate[1]
					})
					.then(function(response) {
						if(response.data.code == "600") {

						} else if(response.data.code == "400") {
							that.$message({
								type: "error",
								message: "操作失败"
							});
						} else {
							that.ifLogin();
						}

					})
					.catch(function(error) {
						//console.log(error);
					});
				}

			},
			getVipPerSons: function(page,nickname) {
				var that = this;
				//console.log("@@@@@@@@@@@@@");
				that.axios.post("/wxUser/one", {
					mark: localStorage.getItem("mark"),
					page:page,
					id:nickname
				})
				.then(function(response) {
					console.log(response);
					if(response.data.code == "600") {
              /**
               * 2020-02-15更新根据学员ID进行查找
               */
              var tempData = [response.data.data];
              var dataTotal = 1;
						that.tableData = tempData;
						that.dataTotal = dataTotal;
					} else if(response.data.code == "400") {
						that.$message({
							type: "error",
							message: "操作失败"
						});
					} else {
						that.ifLogin();
					}
				})
				.catch(function(error) {
					console.log(error);
				});
			},
			handleEdit: function() {

			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},

		},
		watch: {
//			'conponMon': function(val, oldVal) {
//				var that = this;
//				if(val <= 0) {
//					that.$message({
//						type: "error",
//						message: "优惠券金额不能低于0元"
//					});
//					that.sendState = true;
//				} else if(val>0 && that.rangeDate!=null){
//					that.sendState = false;
//				}
//			},
			'rangeDate':function(val, oldVal){
				var that = this;
				console.log(val);
				if(val == null || val == undefined) {
					that.$message({
						type: "error",
						message: "未设置起止时间"
					});
					that.sendState = true;
				}else{
					that.sendState = false;
				}
//				else if(that.conponMon >0){
//					that.sendState = false;
//				}
			},
			'typeId':function(val, oldVal){
				console.log(val);
			}
		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="scoped">
	.clearfix:after,
	#container:after {
		content: "\0020";
		display: block;
		height: 0;
		clear: both;
		visibility: hidden;
		overflow: hidden
	}

	.editConpon {
		background: #fff;
		padding: 20px;
		margin-bottom: 20px;
	}

	.editConpon .box_item {
		margin-bottom: 15px;
		width:50%;
	}
	.myCoupon .coupon_card{
		padding:20px;
	}

	.myCoupon .item {
	  box-shadow: 0 0 10px #ccc;
	  background: #fff;
	  padding:6px 23px;
	  margin-bottom:10px;
	  border-radius:6px;
	  position: relative;
	  overflow:hidden;
	}
	.myCoupon .item .delconpon{
		position:absolute;
		right:10px;
		bottom:10px;
		color:#d00;
		font-size:22px;
	}
	.myCoupon .item .delconpon:hover{
		font-weight:600;
		cursor:pointer;
	}
	.myCoupon .item._no{
	  font-size:18px;
	  line-height:36px;
	}

	.myCoupon .item .choiced_img {
	  position: absolute;
	  right:30px;
	  bottom:20px;
	  width:160px;
	  height:50px;
	  background: #c6c6c6;
	  border-radius:30px;
	  font-size:25px;
	  text-align:center;
	  line-height:50px;
	  background:#f74459;
	}
	.myCoupon .item .choiced_img a{
		color:#fff;
	}
	.myCoupon .item .choiced_img._use {
	  background: #e3432d;
	}

	.myCoupon .item .choiced_img img {
	  width: 100%;
	  height: 100%;
	  display: block;
	}

	.myCoupon .item ._detail {
	  color: #f74459;
	  position: relative;
	  margin-bottom:10px;
	  font-size:14px;
	}

	.myCoupon .item ._detail ._big {
	  font-size:26px;
	  font-weight: 600;
	}

	.myCoupon .item ._detail .item_points {
	  position: absolute;
	  right: 0;
	  top:2px;
	  color: #898989;
	  font-size:14px;
	  margin:0;
	}

	.myCoupon .item ._time {
	  color: #898989;
	  font-size:14px;
	  line-height:25px;
	}

	.myCoupon .plusNum {
	  /* position: fixed;
	  right: 0;
	  bottom: 0; */
	  height:70px;
	  display: flex;
	  flex-direction: row;
	  flex-wrap: wrap;
	}

	.myCoupon .plusNum ._use {
	  background: #1aad16;
	  color: #fff;
	  width:20%;
	  text-align:center;
	  line-height:70px;
	  font-size:18px;
	}
	.myCoupon .plusNum ._price {
	  width:80%;
	  line-height:50px;
	  text-align:right;
	  box-sizing:border-box;
	  padding-right:30px;
	}
	.myCoupon .plusNum ._price text{
	  font-size:24px;
	  color:#f74459;
	}

	.myCoupon .item ._used{
	  position:absolute;
	  width:90px;
	  height:90px;
	  right:160px;
	  top:3px;
	  z-index: 2;
	}
	.myCoupon .item ._used img{
	  display:block;
	  width:100%;
	  height:100%;
	}

</style>



// WEBPACK FOOTER //
// src/components/ConponPage.vue